// @flow

import React, { type Node } from 'react';

import { type LookAndFeelRootPropsPendingPayment } from '@tectonics/look-and-feel';

import { ContextProvider } from './context-provider';
import { PageTemplate } from '../../commons/templates';
import { PaymentMethod } from './payment-method';

export function PendingPaymentPage(props: LookAndFeelRootPropsPendingPayment): Node {
  return (
    <ContextProvider {...props}>
      <PageTemplate data-test-id="page-pending-payment">
        <PaymentMethod />
      </PageTemplate>
    </ContextProvider>
  );
}
